import { PlayerModel } from '@modules/player/player-model';

const fields = new PlayerModel().fields();

export default [
  fields.firstName,
  fields.lastName,
  fields.country,
  fields.gender,
];
